import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

import { RebillyCreatePaymentToken } from '../models'
import { REBILLY_PUBLICKEYS, REBILLY_URLS } from './api'

interface CreatePaymentTokenResponse {
  id?: string
  invalidFields?: [
    {
      message?: string
    },
  ]
  message?: string
}

export const createPaymentToken = async (params: RebillyCreatePaymentToken) => {
  const { sandbox } = params
  const options: AxiosRequestConfig = {
    headers: {
      Authorization: sandbox ? REBILLY_PUBLICKEYS.local : REBILLY_PUBLICKEYS.prod,
      'Content-Type': 'application/json',
    },
  }

  try {
    const response = await axios.post<RebillyCreatePaymentToken, AxiosResponse<CreatePaymentTokenResponse>>(
      `${sandbox ? REBILLY_URLS.local : REBILLY_URLS.prod}/tokens`,
      params,
      options,
    )
    const responseData = response.data
    if (response.status !== 200 && responseData.invalidFields) {
      const invalidFieldMessage = responseData.invalidFields.map((field: { message?: string }) => {
        return field.message
      })
      responseData.message = invalidFieldMessage.join('/n')

      throw Error(responseData.message)
    }
    return responseData.id
  } catch (ex) {
    const error = ex as AxiosError
    if (error.response) {
      console.error(`createPaymentToken: ${JSON.stringify(error.response.data)}`)
    }
    throw ex
  }
}
